import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WishlistPage.css';

const WishlistPage = ({ wishlistItems = [], removeFromWishlist, addToCart, user }) => {
    const navigate = useNavigate();

    const handleMoveToCart = (item) => {
        const productToAdd = {
            ...item,
            selectedWeight: item.unit || '1 unit',
            price: item.price
        };
        if (addToCart) addToCart(productToAdd);
        
        // Safety check for removal
        if (removeFromWishlist) {
            removeFromWishlist(item.id || item); 
        }
    };

    // Robust removal handler
    const handleQuickRemove = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (removeFromWishlist) {
            removeFromWishlist(item.id || item);
        }
    };

    // FIXED: Double check for user existence to prevent ReferenceErrors
    const isUserLoggedIn = user && Object.keys(user).length > 0;

    return (
        <div className="wishlist-container">
            <div className="wishlist-content-wrapper">
                {/* Header Section */}
                <div className="wishlist-header-modern">
                    <div className="header-text">
                        <h1>My Favorites</h1>
                        <p>
                            {/* FIXED: Added optional chaining user?.name */}
                            {isUserLoggedIn 
                                ? `Hi ${user?.name || 'there'}, here are items you've saved` 
                                : "Items you've saved from the Mart"}
                        </p>
                    </div>
                    <div className="header-badge">
                        <span className="pulse-icon">❤️</span>
                        <span>{wishlistItems.length} Saved Items</span>
                    </div>
                </div>

                {!isUserLoggedIn ? (
                    <div className="bright-empty-state">
                        <div className="illustration-wrap">
                            <span className="floating-heart">🔒</span>
                        </div>
                        <h3>Please login to see your favorites</h3>
                        <p>Your personalized wishlist is available once you sign in.</p>
                        <button className="shop-now-btn" onClick={() => navigate('/agro')}>
                            Go to Shop
                        </button>
                    </div>
                ) : wishlistItems.length === 0 ? (
                    <div className="bright-empty-state">
                        <div className="illustration-wrap">
                            <span className="floating-heart">❤️</span>
                            <div className="basket-icon">🧺</div>
                        </div>
                        <div classname = "text"> 
                            <h3>Your wishlist is waiting!</h3>
                        <p>Explore our fresh organic produce and save your favorites here.</p>
                        </div>
                        
                        <button className="shop-now-btn" onClick={() => navigate('/agro')}>
                            Start Shopping
                        </button>
                    </div>
                ) : (
                    <div className="wishlist-grid-refined">
                        {wishlistItems.map((item) => (
                            <div key={item.id || Math.random()} className="refined-card">
                                <div className="card-img-container">
                                    <img 
                                        src={item.image ? `https://atrmart.in/storage/${item.image}` : 'https://via.placeholder.com/300x200'} 
                                        alt={item.name} 
                                        className="product-img"
                                    />
                                    {item.category && <span className="category-pill">{item.category}</span>}
                                    
                                    <button 
                                        className="quick-remove" 
                                        onClick={(e) => handleQuickRemove(e, item)}
                                        title="Remove"
                                    >
                                        ✕
                                    </button>
                                </div>
                                
                                <div className="card-details">
                                    <h3 className="refined-title">{item.name}</h3>
                                    <div className="price-row">
                                        <span className="currency">₹</span>
                                        <span className="amount">{item.price}</span>
                                    </div>
                                    
                                    <div className="refined-actions">
                                        <button className="primary-move-btn" onClick={() => handleMoveToCart(item)}>
                                            <span>Add to Cart</span>
                                            <i className="cart-icon">🛒</i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WishlistPage;